import React from 'react';

import InfoOutlined from '@mui/icons-material/InfoOutlined';
import Box from '@mui/material/Box';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';

import Typography from '@mui/material/Typography';

import { MENU_BACKGROUND_COLOR, TIP_INFO_ICON_COLOR } from '../constants';

export const TipsMenuItem = () => {
  return (
    <Box
      sx={{
        '& .Mui-disabled': {
          opacity: `1 !important`,
        },
        '& .MuiMenuItem-root': {
          textAlign: 'left',
        },
        backgroundColor: MENU_BACKGROUND_COLOR,
        flexShrink: 0,
        zIndex: 1,
      }}
    >
      <MenuItem disabled={true} sx={{ justifyContent: 'flex-start', p: 1, pointerEvents: 'none' }}>
        <ListItemIcon sx={{ mr: 0 }}>
          <InfoOutlined
            sx={{ color: `${TIP_INFO_ICON_COLOR} !important`, fontSize: '1.25rem' }}
          />{' '}
        </ListItemIcon>
        <ListItemText
          primary={`Type "(" to start a group of filters.`}
          slotProps={{
            primary: {
              color: 'secondary.main',
              sx: { fontSize: '0.8rem', whiteSpace: 'normal' },
            },
          }}
        />
      </MenuItem>
      <MenuItem disabled={true} sx={{ justifyContent: 'flex-start', p: 1, pointerEvents: 'none' }}>
        <ListItemIcon sx={{ mr: 0 }}>
          <InfoOutlined
            sx={{ color: `${TIP_INFO_ICON_COLOR} !important`, fontSize: '1.25rem' }}
          />{' '}
        </ListItemIcon>
        <ListItemText
          primary={`Use "quoted text" to search across all fields.`}
          slotProps={{
            primary: {
              color: 'secondary.main',
              sx: { fontSize: '0.8rem', whiteSpace: 'normal' },
            },
          }}
        />
      </MenuItem>
      <MenuItem disabled={true} sx={{ justifyContent: 'flex-start', p: 1, pointerEvents: 'none' }}>
        <ListItemText
          primary={
            <span>
              Press{' '}
              <Typography component="span" sx={{ color: 'primary.main', fontSize: 'inherit' }}>
                Enter
              </Typography>{' '}
              to submit
            </span>
          }
          slotProps={{
            primary: {
              color: 'secondary.main',
              sx: { fontSize: '0.8rem', whiteSpace: 'normal' },
            },
          }}
        />
      </MenuItem>
    </Box>
  );
};
